import React, { useState } from 'react'

import { ToolbarButton } from '@fourthwall/components'
import { DownloadIcon } from '@fourthwall/icons'

import { AnalyticsTooltip } from '../../../../analyticsModule/components/AnalyticsTooltip/AnalyticsTooltip'
import { ReportTooltip } from '../ReportTooltip/ReportTooltip'

type ExportButtonProps = {
  disabled?: boolean
  tooltipMessage?: string
  onExport: () => Promise<void>
}

export const ReportExportButton = ({
  disabled = false,
  tooltipMessage,
  onExport,
}: ExportButtonProps) => {
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    setIsExporting(true)
    await onExport()
    setIsExporting(false)
  }

  const renderButton = () => (
    <ToolbarButton
      label="Export"
      disabled={disabled}
      isLoading={isExporting}
      icon={DownloadIcon}
      onClick={handleExport}
    />
  )

  if (disabled && tooltipMessage) {
    return (
      <AnalyticsTooltip content={<ReportTooltip content={tooltipMessage} />}>
        {renderButton()}
      </AnalyticsTooltip>
    )
  }

  return renderButton()
}
